
import { Vue, Component, Ref, Prop, Watch } from 'vue-property-decorator';
import VehicleModule from '@/components/carModule/VehicleModule.vue';

@Component({
  components: {
    VehicleModule,
  },
})
export default class BrandCarSeriesModelsField extends Vue {
  name = 'NameField';
  val = '';

  @Ref()
  vehicleModule!: VehicleModule;

  @Prop()
  readonly!: boolean;

  @Prop()
  disabled!: boolean;

  @Prop()
  form!: any;

  @Prop()
  value!: any;

  init() {
    this.vehicleModule.init();
  }

  @Watch('value', { deep: true, immediate: true })
  watchValue() {
    console.log(this.value, 'watchValue');
    if (this.value) {
      if (this.value.brand && this.value.series && this.value.modelName) {
        // 组合品牌、车系和车型名称
        this.val = `${this.value.brand}/${this.value.series}/${this.value.modelName}`;
      } else {
        this.val = '';
      }
    } else {
      // 清空显示值
      this.val = '';
    }
  }

  mounted() {
    this.watchValue();
  }

  updateName(name: any) {
    this.val = `${name.brand}/${name.series}/${name.modelName}`;
    console.log(name);
    this.$emit('update', name);
    this.$emit('brandCarSeriesModels', name);
  }
}
